import { handleActions } from 'redux-actions';
import ClientsTypes from '../types/ClientsType';
import { GridFilters, initialStateList } from './GridFiltersReducer';

const initialState = {
  allClients: { ...initialStateList },
  availableCountries: [],
};

export const Clients = handleActions(
  {
    ...GridFilters,
    [ClientsTypes.actions.fetchClientFiltersSuccess]: (state, { payload: { availableCountries } }) => ({ ...state, availableCountries }),
  },
  initialState
);

const getClients = (state) => state.Clients;

export const getClientsList = (state, list) => {
  const clients = getClients(state);
  return clients[list] || undefined;
};
